import React, {Fragment} from 'react';
import {compose} from "redux";
import {translate} from 'react-i18next';
import _ from "lodash";
import {Checkbox, Col, Form, Input, Row} from "antd";
import InputListForm from "../../../../components/input-list-form";
import {GUTTER_MD} from "../../../../styles/constants";
import { isIDValidWithHelp, isStrTripletValidWithHelp } from '../../../../utils/artefactValidators';

const upperCaseStyle = {
  textTransform: "uppercase"
};

const mapPropsToFields = ({AST}) => ({
  Enabled: Form.createFormField({value: (AST && AST.Enabled) ? AST.Enabled : false}),
  TerritorialDimIds: Form.createFormField({value: (AST && AST.TerritorialDimIds) ? AST.TerritorialDimIds : []}),
  ASTTerritoryDimId: Form.createFormField({value: (AST && AST.ASTTerritoryDimId) ? AST.ASTTerritoryDimId : ""}),
  ASTTerritorialCodelist: Form.createFormField({value: (AST && AST.ASTTerritorialCodelist) ? AST.ASTTerritorialCodelist : ""}),
  ASTTerritoryConceptScheme: Form.createFormField({value: (AST && AST.ASTTerritoryConceptScheme) ? AST.ASTTerritoryConceptScheme : ""}),
  ASTTerritoryConcept: Form.createFormField({value: (AST && AST.ASTTerritoryConcept) ? AST.ASTTerritoryConcept : ""})
});

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const AstForm = ({
                   t,
                   form
                 }) =>
  <Fragment>
    <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD} style={{marginBottom: 0}}>
      <Col style={{color: 'rgba(0, 0, 0, 0.85)'}}>
        {t("data.nodesConfig.ast.enabled.label") + ' :'}
      </Col>
      <Col>
        <Form.Item>
          {form.getFieldDecorator("Enabled", {valuePropName: 'checked'})(
            <Checkbox/>
          )}
        </Form.Item>
      </Col>
    </Row>
    {form.getFieldValue('Enabled') && (
      <Fragment>
        <Form.Item
          label={t('data.nodesConfig.ast.territorialDimIds.label')}
          className="form-item-required"          
        >
          {form.getFieldDecorator('TerritorialDimIds', {valuePropName: 'values'})(
            <InputListForm
              addItemLabel={t('scenes.configuration.nodesConfig.ast.territorialDimIds.addButton.title')}
              removeItemLabel={t('scenes.configuration.nodesConfig.ast.territorialDimIds.removeButton.title')}
              validateId
            />
          )}
        </Form.Item>
        <Form.Item
          label={t('data.nodesConfig.ast.astTerritoryDimId.label')}
          className="form-item-required"
          validateStatus={form.getFieldValue('ASTTerritoryDimId') && isIDValidWithHelp(t, form.getFieldValue('ASTTerritoryDimId')).help ? "warning" : null}
          help={form.getFieldValue('ASTTerritoryDimId') && isIDValidWithHelp(t, form.getFieldValue('ASTTerritoryDimId')).help}
        >
          {form.getFieldDecorator('ASTTerritoryDimId', 
            {getValueFromEvent: e => (e.target.value || "").toUpperCase()})(
            <Input
              style={upperCaseStyle}
            />)}
        </Form.Item>
        <Form.Item
          label={t('data.nodesConfig.ast.astTerritorialCodelist.label')}
          className="form-item-required"
          validateStatus={form.getFieldValue('ASTTerritorialCodelist') && isStrTripletValidWithHelp(t, form.getFieldValue('ASTTerritorialCodelist')).help ? "warning" : null}
          help={form.getFieldValue('ASTTerritorialCodelist') && isStrTripletValidWithHelp(t, form.getFieldValue('ASTTerritorialCodelist')).help}        
        >
          {form.getFieldDecorator('ASTTerritorialCodelist', 
            {getValueFromEvent: e => (e.target.value || "").toUpperCase()})(
            <Input
              style={upperCaseStyle}
            />)}
        </Form.Item>
        <Form.Item
          label={t('data.nodesConfig.ast.astTerritoryConceptScheme.label')}
          className="form-item-required"
          validateStatus={form.getFieldValue('ASTTerritoryConceptScheme') && isStrTripletValidWithHelp(t, form.getFieldValue('ASTTerritoryConceptScheme')).help ? "warning" : null}
          help={form.getFieldValue('ASTTerritoryConceptScheme') && isStrTripletValidWithHelp(t, form.getFieldValue('ASTTerritoryConceptScheme')).help}        
        >
          {form.getFieldDecorator('ASTTerritoryConceptScheme', 
            {getValueFromEvent: e => (e.target.value || "").toUpperCase()})(
            <Input
              style={upperCaseStyle}
            />)}
        </Form.Item>
        <Form.Item
          label={t('data.nodesConfig.ast.astTerritoryConcept.label')}
          className="form-item-required"
          validateStatus={form.getFieldValue('ASTTerritoryConcept') && isIDValidWithHelp(t, form.getFieldValue('ASTTerritoryConcept')).help ? "warning" : null}
          help={form.getFieldValue('ASTTerritoryConcept') && isIDValidWithHelp(t, form.getFieldValue('ASTTerritoryConcept')).help}
        >
          {form.getFieldDecorator('ASTTerritoryConcept', 
            {getValueFromEvent: e => (e.target.value || "").toUpperCase()})(
            <Input
              style={upperCaseStyle}
            />)}
        </Form.Item>
      </Fragment>
    )}
  </Fragment>;

export default compose(
  translate(),
  Form.create({mapPropsToFields, onFieldsChange})
)(AstForm);



// WEBPACK FOOTER //
// ./src/scenes/configuration/nodes-config/node/AstForm.jsx